<template>
  <div class="clearfix fs13 p20 detail-row-last">
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="topic"
      :comment-highlights="commentHighlights"
      text-count-class="topic"
      :text-counts="textCounts"
      v-on="$listeners"
    />
    <div class="fll row-left">
      <p
        v-if="freeTopic.title"
        :id="`${targetIdMap.freeTopics.title}-${freeTopic.index}`"
        class="fwB"
        data-test="title"
        v-text="freeTopic.title"
      />
      <p
        :id="`${targetIdMap.freeTopics.body}-${freeTopic.index}`"
        class="pega-pre-wrap"
        data-test="body"
        v-text="freeTopic.body"
      />
    </div>
    <div class="flr">
      <img
        v-if="freeTopic.photo"
        :id="`${targetIdMap.freeTopics.photo}-${freeTopic.index}`"
        :src="getPhotoUrl(freeTopic.photo)"
        class="offer-img-sub"
        data-test="photo"
        @load="$emit('onLoadImage')"
        @error="$emit('onLoadImage')"
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewRightColumn
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    freeTopic: {
      type: Object,
      default: () => {}
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    textCounts () {
      return [
        this.getTextCount(`フリートピックス[${this.freeTopic.index}]タイトル`, this.freeTopic.title, this.targetIdMap.freeTopics.title),
        this.getTextCount(`フリートピックス[${this.freeTopic.index}]本文`, this.freeTopic.body, this.targetIdMap.freeTopics.body)
      ]
    }
  }
}
</script>
